import { render } from "./DataAnalysis.vue?vue&type=template&id=3a612aab&scoped=true"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"

import "./DataAnalysis.vue?vue&type=style&index=0&id=3a612aab&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a612aab"]])

export default __exports__